var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contact"},[_c('div',{staticClass:"contact-row"},[_vm._v("理赔服务：4000999559-1")]),_c('div',{staticClass:"contact-row"},[_vm._v("其他服务：4000999559-2")]),_c('div',{staticClass:"contact-row"},[_vm._v("投诉建议：4000999559-3")]),_c('div',{staticClass:"contact-line"}),_c('div',{staticClass:"contact-time"},[_vm._v(" 工作时间：周一 ~ 周日 10:00-20:00 ")])])
}]

export { render, staticRenderFns }